import { render, staticRenderFns } from "./StockEditMobile.vue?vue&type=template&id=347d4989"
import script from "./StockEditMobile.vue?vue&type=script&lang=ts"
export * from "./StockEditMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347d4989')) {
      api.createRecord('347d4989', component.options)
    } else {
      api.reload('347d4989', component.options)
    }
    module.hot.accept("./StockEditMobile.vue?vue&type=template&id=347d4989", function () {
      api.rerender('347d4989', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockEditMobile.vue"
export default component.exports